/**
 * Human-readable calculation breakdown for accounting findings.
 */
function formatCell(value) {
  if (value == null || value === '') return '—';
  return String(value);
}

function buildDetailsCell(row) {
  const parts = [];
  if (row.expected != null && row.expected !== '') {
    parts.push(`Should be: ${row.expected}`);
  }
  if (row.difference != null && row.difference !== '') {
    parts.push(`Difference: ${row.difference}`);
  }
  if (row.note) {
    parts.push(row.note);
  }
  return parts.length ? parts.join(' · ') : '—';
}

export default function FindingCalculationDetails({ details, severity = 'warning' }) {
  if (!details?.rows?.length) {
    return null;
  }

  const boxClass = severity === 'critical' ? 'critical' : 'warning';

  return (
    <div className={`accounting-calc-box admin-alert-item ${boxClass} mt-2 mb-0`}>
      <strong className="d-block mb-2">{details.title || 'Calculation details'}</strong>
      <div className="table-responsive">
        <table className="table table-sm accounting-calc-table mb-0">
          <thead>
            <tr>
              <th>Item</th>
              <th>Value found</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {details.rows.map((row, index) => (
              <tr key={`${row.label}-${index}`} className={row.highlight ? 'accounting-calc-highlight' : ''}>
                <td>{formatCell(row.label)}</td>
                <td>{formatCell(row.value)}</td>
                <td className="small">{buildDetailsCell(row)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {details.where_to_fix && (
        <p className="small mb-0 mt-2">
          <strong>Where to correct:</strong> {details.where_to_fix}
        </p>
      )}
    </div>
  );
}
